module.exports = __webpack_public_path__ + "static/media/4.d7ee0a3e.jpg";